import { putFileToPresignedUrl } from '@/lib/api/navImageUpload';
import { courseKeysApi } from '@/lib/api/courseKeys';
import type { CourseKeyInstructionFile } from '@/types/course-key';

export const COURSE_KEY_INSTRUCTION_ALLOWED_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/webp',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
] as const;

export const COURSE_KEY_INSTRUCTION_MAX_BYTES = 10 * 1024 * 1024;

export function validateCourseKeyInstructionFile(file: File): void {
  if (
    !COURSE_KEY_INSTRUCTION_ALLOWED_TYPES.includes(
      file.type as (typeof COURSE_KEY_INSTRUCTION_ALLOWED_TYPES)[number]
    )
  ) {
    throw new Error('Invalid file type. Allowed: PDF, JPEG, PNG, WebP, DOC, DOCX.');
  }
  if (file.size > COURSE_KEY_INSTRUCTION_MAX_BYTES) {
    throw new Error('File is too large. Max size is 10 MB.');
  }
}

export async function uploadCourseKeyInstructionFile(
  file: File
): Promise<CourseKeyInstructionFile> {
  validateCourseKeyInstructionFile(file);
  const presign = await courseKeysApi.presignInstructionFileUpload({
    fileName: file.name,
    fileType: file.type,
    fileSize: file.size,
  });
  await putFileToPresignedUrl(presign.uploadUrl, file);
  return {
    fileName: file.name,
    fileUrl: presign.fileUrl,
    fileType: file.type,
    fileSize: file.size,
  };
}
